import { UserInfo } from 'firebase/app';

export class Constants {
  public static USER: UserInfo;
  public static EVENT_URL = '/EventWeb';
  public static EVENT_APP_URL = '/EventApp';
  public static EVENT_ALIAS_URL = '/EventAlias';
  public static EVENT_LIST_URL = '/EventList';
  public static EVENT_EDITOR_LIST_URL = '/EventEditorList';
  public static EVENT_USER_DATA_URL = '/EventUserData';
  public static EVENT_BASIC_INFO = '/basicInfo';
  public static EVENT_ABOUT_URL = '/About';
  public static STORAGE_SPLASH_URL = '/Splash';
  public static STORAGE_VENUE_URL = '/Venue';
  public static EVENT_MENU_ITEMS = '/menuItems';
  public static PROFILE_URL = '/Profile';
  public static PROFILE_IMAGES_BASE_URL = 'ProfileImages/';
  public static EVENT_OWNER = '/owner';
  public static EVENT_VERSION = '/version';
  public static NOTES_HISTORY = '/notesHistory';
  public static Contents_Mandatory_URL = '/ContentsMandatory';

  public static PREDERENCES_URL = '/Preferences';
  public static PREF_DISCLAIMER = '/disclaimer';
  public static PREF_DISABLE_FEATURES = '/disableFeatures';
  public static PREF_LISTING_URL = '/listing';
  public static PREF_HIDE_IMAGE = '/hideImage';
  public static VENUE_URL = '/venue';
  public static SPLASH_URL = '/splash_map';

  public static LIST_CATEGORY_SPEAKER = '/has_category_speaker';
  public static LIST_CATEGORY_SPONSOR = '/has_category_sponsor';
  public static LIST_CATEGORY_EXHIBITOR = '/has_category_exhibitor';
  public static LIST_CATEGORY_ORGANIZER = '/has_category_organizer';
  public static LIST_CATEGORY_TRACK = '/has_category_track';
  public static LIST_CATEGORY_TYPE = '/has_category_type';
  public static NODE_PREF_SESSION_HSH = '/hasSessionHalls';

  public static HIDE_IMAGE_SPEAKER = '/hideImageSpeaker';
  public static HIDE_IMAGE_SPONSOR = '/hideImageSponsor';
  public static HIDE_IMAGE_EXHIBITOR = '/hideImageExhibitor';
  public static HIDE_IMAGE_ORGANIZER = '/hideImageOrganizer';

  public static CATEGORY_SPONSORS = '/SponsorsType';
  public static CATEGORY_SPEAKERS = '/SpeakersType';
  public static CATEGORY_EXHIBITORS = '/ExhibitorsType';
  public static CATEGORY_ORGANIZERS = '/OrganizersType';
  public static CATEGORY_SESSION_TOPIC = '/SessionTopic';
  public static CATEGORY_SESSION_TRACK = '/SessionTrack';
  public static CATEGORY_SESSION_TYPE = '/SessionType';
  public static NODE_SESSION_HALL = '/SessionHall';


  public static MCML_URL = '/menu_content_mandatory_list';
  public static SESSION_URL = '/Session';
  public static SESSION_TOPIC_URL = '/SessionTopics';
  public static CONTENT_URL = '/Contents';
  public static Poll_URL = '/Poll';
  public static Poll_QUESTION_URL = '/PollQuestion';
  public static Poll_OPTIONS_URL = '/PollOptions';
  public static CONTACT_US_URL = '/ContactUs';

  public static SPEAKER_URL = '/Speaker';
  public static SPONSORS_URL = '/Sponsors';
  public static EXHIBITORS_URL = '/Exhibitors';
  public static ORGANIZERS_URL = '/Organizers';

  public static QUESTIONS_URL = '/Questions';
  public static FEEDBACK_URL = '/Feedback';
  public static POLL_ANSWERS_URL = '/PollAnswers';
  public static INVITES_URL = '/Invites';
  public static PREF_THEME = '/theme';

  public static LOGIN_URL = 'user/login';
  public static FORGOT_PASS_URL = 'user/forgot-password';
  public static WELCOME_URL = 'welcome';
  public static INFO_URL = 'event/info';
  public static MENU_TYPE_URL = 'event/menu-type';
  public static MENU_ITEMS_URL = 'event/menu-items';
  public static ABOUT_US_URL = 'event/about-us';
  public static THEME_URL = 'event/theme';

  public static SPONSORS_FORM = '/event/sponsors-form';
  public static SESSION_FORM = '/event/sessions-form';
  public static SPEAKER_FORM = '/event/speakers-form/';
  public static POLL_FORM = '/event/poll-form/';
  public static CONTACT_US_FORM = '/event/contact-us-form/';
  public static CONTENT_FORM = '/event/content-form/';
  public static EXHIBITOR_FORM = '/event/exhibitors/';
  public static ORGANIZER_FORM = '/event/organizers/';

  public static ABOUT_TYPE_TEXT_PREF_SIZE = 'textsize';
  public static ABOUT_TYPE_TEXT_PREF_COLOR = 'textcolor';
  public static ABOUT_TYPE_TEXT_PREF_STYLE = 'textstyle';
  public static ABOUT_TYPE_TEXT_PREF_STYLE_NORMAL = 'normal';
  public static ABOUT_TYPE_TEXT_PREF_STYLE_BOLD = 'bold';
  public static ABOUT_TYPE_TEXT_PREF_STYLE_ITALIC = 'italic';
  public static ABOUT_TYPE_TEXT_PREF_STYLE_BOLDITALIC = 'bolditalic';
  public static ABOUT_TYPE_URL_PREF_STYLE = 'urlstyle';
  public static ABOUT_TYPE_URL_PREF_STYLE_URL = 'url';
  public static ABOUT_TYPE_URL_PREF_STYLE_BUTTON = 'button';
  public static ABOUT_TYPE_YOUT_PREF_CM_ID = 'youtubeCustomImageCMId';

  // public static IMAGE_UPLOAD_TYPE_LOGO = 'logo';
  public static IMAGE_UPLOAD_TYPE_BANNER = 'banner';
  public static IMAGE_UPLOAD_TYPE_ICON = 'icon';
  public static THEME_TYPE_EXISTING = 'THEME_TYPE001';
  public static THEME_TYPE_CREATED = 'THEME_TYPE002';


  //For Attendies//
  public static ATTENDING = 'Attending';
  public static NOT_ATTENDING = 'Not attending';
  public static MAYBE = 'Maybe';
  public static NOT_RESPONDED = 'Not responded';

  public static SUBMIT_BUTTON_MESSAGE = 'Changes will not be saved if you don\'t click SAVE manually';

  public static VIDEO_SIZE = 20000000;
  public static VIDEO_SIZE_ERROR_MESSAGE_SUMMARY = 'Video should not be larger than 20MB.';
  public static VIDEO_SIZE_ERROR_MESSAGE_DETAIL = 'We encourage you to upload the video on youtube & use it\'\s URL instead.';
  public static VIDEO_SIZE_LABEL = Constants.VIDEO_SIZE_ERROR_MESSAGE_SUMMARY + ' ' + Constants.VIDEO_SIZE_ERROR_MESSAGE_DETAIL;

  public static LABEL_PUBLIC_EVENT_DESCRIPTION = '   (PUBLIC events are open to general public; PRIVATE events are open to invited guests only)';
  public static LABEL_SHORT_VENUE_DESCRIPTION = '   (Short address for viewing on mobile screens Eg. Hyatt Regency, Gurgaon is the short address for Hyatt Regency, New Delhi NCR, NH8, Sector 83, Gurgaon, India, 122004)';
  public static NO_FEEDBACK_DESCRIPTION = 'No Feedback is given by your attendees';
  public static PUBLISH_AT_DATE_FORMAT = 'dd-MM-yyyy HH:mm a';

  public static PUBLISH_LABEL1 = 'Once you publish, all your changes will become visible to the public.';
  public static RESET_LABEL1 = 'THIS ACTION CAN\'\T BE UNDONE';
  public static RESET_LABEL2 = 'Once you publish, all your changes since the last publish will be DELETED.';

  public static MODAL_LABEL1 = 'Unexpected bad things may happen if you don\'\t read this!';

  public static DELETE_MSG_POLL = 'Are you sure, you want to delete the poll?';
  public static DELETE_MSG_SESSION = 'Are you sure, you want to delete the session?';
  public static DELETE_MSG_SPEAKER = (...args: any[]) => { return `Are you sure, you want to delete speaker?`};
  public static DELETE_MSG_SPONSOR = 'Are you sure, you want to delete the sponsor?';
  public static DELETE_MSG_EXH = 'Are you sure, you want to delete the exh?';
  public static DELETE_MSG_CONTENT = 'Are you sure, you want to delete the content?';
  public static DELETE_MSG_CONTACT = 'Are you sure, you want to delete the contact?';
  public static DELETE_MSG_SESSION_TRACK = 'Are you sure, you want to delete the track?';
  public static DELETE_MSG_SESSION_TYPE = 'Are you sure, you want to delete the type?';
  public static DELETE_MSG_MULTIPLE_SPEAKER = (...args: any[]) => {let count = args?args[0]:''; return `Are you sure, you want to delete all ${count} selected speakers?`};

  public static CONTENT_M_TYPE_ABOUT = 'About';
  public static CONTENT_M_TYPE_BG = 'BGImage';
  public static CONTENT_M_TYPE_EXHIBITORS = 'Exhibitors';
  public static CONTENT_M_TYPE_ORGANIZERS = 'Organizers';
  public static CONTENT_M_TYPE_LOGO = 'CustomLogo';
  public static CONTENT_M_TYPE_MENU = 'Menu';
  public static CONTENT_M_TYPE_SESSION = 'Session';
  public static CONTENT_M_TYPE_SPLASH = 'Splash';
  public static CONTENT_M_TYPE_SPONSORS = 'Sponsors';
  public static CONTENT_M_TYPE_OTHERS = 'Others';
  public static CONTENT_M_TYPE_VENUE = 'Venue';
  // public static SPONSORS_IMAGES = '/Sponsors';
  // public static CONTENTS_FILES = '/ContentFiles';
  // public static SPEAKER_IMAGES = '/SpeakersImages';
  public static CONTENT_M_TYPE_SPEAKERS = 'Speakers';
  public static CONTENT_M_TYPE_CONTENTS = '/Contents';

  public static DATE_TIME_FORMAT = 'ddMMyyyy HH:mm:ss';

  public static DELETE_MSG_POLL_QUESTION = 'Are you sure, you want to delete the poll question?';

}

export const  MENU_ITEM_LIST = [
// The value field is realName from Android model point of view. It can't be changed

  { checked: false, name: 'About', value: 'About', url: '/event/about-us' },
  { checked: false, name: 'About City', value: 'aboutCity', url: '/event/AboutCity' },
  { checked: false, name: 'Attendees', value: 'attendees', url: '/event/attendees' },
  { checked: false, name: 'Activities', value: 'activities', url: '/event/activities' },
  { checked: false, name: 'Content', value: 'Content', url: '/event/content-form' },
  { checked: false, name: 'Chatroom', value: 'chatroom', url: '/event/chatroom' },
  { checked: false, name: 'Contact Us', value: 'Contact Us', url: '/event/contact-us-form' },
  { checked: false, name: 'Exhibitors', value: 'Exhibitors', url: '/event/exhibitors' },
  { checked: false, name: 'Feedback', value: 'Feedback', url: '/event/feedback' },
  { checked: false, name: 'Notifications', value: 'notifications', url: '/event/notification' },
  { checked: false, name: 'Notes', value: 'notes', url: '/event/notes' },
  { checked: false, name: 'Organizers', value: 'Organizers', url: '/event/organizers' },
  { checked: false, name: 'Polls', value: 'Polls', url: '/event/poll-form' },
  { checked: false, name: 'QnA', value: 'QnA', url: '/event/question-and-answer' },
  { checked: false, name: 'Registration', value: 'registration', url: '/event/Registration' },
  { checked: false, name: 'Sponsors', value: 'Sponsors', url: '/event/sponsors-form' },
  { checked: false, name: 'Sessions', value: 'Sessions', url: '/event/sessions-form' },
  { checked: false, name: 'My Sessions', value: 'mySessions', url: '/event/MySessions' },
  { checked: false, name: 'Speakers', value: 'Speakers', url: '/event/speakers-form' },
  { checked: false, name: 'Topics', value: 'topics', url: '/event/sessions-topic'  },
  { checked: false, name: 'Venue Details', value: 'VenueDetails', url: '/event/venue-detail' },
  { checked: false, name: 'Streaming', value: 'streaming', url: '/event/Streaming' },
  { checked: false, name: 'Quiz', value: 'quiz', url: '/event/quiz' },
  { checked: false, name: 'Leaderboard', value: 'leaderboard', url: '/event/leaderboard' },
];





// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/config/Constants.ts